import { IDictionary, ISort } from '@/entities';

function readInt($route, key: string, defaultValue: number = 0): number {
    const str = $route.query[key];
    if (str && str.length > 0) {
        return parseInt(str, 10);
    } else {
        return defaultValue;
    }
}

function readBool($route, key: string, defaultValue: boolean = false): boolean {
    const str = $route.query[key];
    if (str !== null && str !== undefined) {
        return str === true || str === 'true';
    } else {
        return defaultValue;
    }
}

function readStr($route, key: string, defaultValue: string = ''): string {
    const str = $route.query[key];
    if (str && str.length > 0) {
        return str;
    } else {
        return defaultValue;
    }
}

export interface QueryChange {
    sort?: ISort;
    page?: number;
}

export default {
    getPage($route): number {
        return readInt($route, 'page', 1);
    },
    getPageSize($route): number {
        return readInt($route, 'pageSize', 50);
    },
    getSort($route, defaultSort: ISort): ISort {
        return {
            field: readStr(
                $route,
                'sortField',
                defaultSort !== null ? defaultSort.field : ''
            ),
            asc: readBool(
                $route,
                'sortAsc',
                defaultSort !== null ? defaultSort.asc : true
            )
        };
    },

    pushChanges($route, $router, req: QueryChange) {
        const q = { ...$route.query };
        if (req.page) {
            q['page'] = req.page.toString();
        }
        if (req.sort) {
            q['sortField'] = req.sort.field;
            q['sortAsc'] = req.sort.asc;
        }
        $router.push({ path: $route.path, query: q });
    },

    pushCriteriaChanges($route, $router, dict: IDictionary<string>) {
        const q = { ...$route.query, ...dict };
        q['page'] = '1'; // drop page if criteria change
        $router.push({ path: $route.path, query: q });
    },
    pushClearParams($route, $router) {
        $router.push({ path: $route.path, query: {} });
    }

    // getCriterias():IDictionary,//all except paging and sorting,
    // changePage($route, $router, page: number) {
    //     const q = { ...$route.query };
    //     q['page'] = page.toString();
    //     $router.push({ path: $route.path, query: q });
    // },

    // sortChange(sort: ISort) {
    //     // reset page and add sortParams to query
    // },
    // applyCriteria(formState: IDictionary) {}
};
